import React from "react";
import Skeleton from "react-loading-skeleton";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

function CartLoader() {
    return (
        <div>
            <Row>
                <Col xs={12} md={12} lg={12}>
                    <Skeleton height={"100"}/>
                </Col>
            </Row>

            <div className={"trinity-container"}>
                <Row style={{marginTop: "1rem"}}>
                    <Col xs={12} md={12} lg={12}>
                        <Skeleton height={"100"}/>
                    </Col>
                </Row>

                <Row style={{marginTop: "2rem", marginBottom: "2rem"}}>
                    <Col xs={12} md={8} lg={8} style={{padding: 10}}>
                        <Skeleton height={500}/>
                    </Col>

                    <Col xs={12} md={4} lg={4} style={{padding: 10}}>
                        <Skeleton height={500}/>
                    </Col>
                </Row>
            </div>
        </div>
    )
}

export default CartLoader;
